import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaCheck, FaHandshake, FaCarAlt, FaUserFriends, FaClock } from 'react-icons/fa';
import './AboutUs.css';

const AboutUs = () => {
    return (
        <div className="about-us-page py-5">
            <Container>
                {/* Header Section */}
                <Row className="mb-5">
                    <Col lg={12} className="text-center">
                        <h1 className="page-title mb-4">HAKKIMIZDA</h1>
                        <div className="title-underline mb-4"></div>
                        <p className="lead mb-4">
                            <strong>2005'ten Gelen Tecrübe, 2020'den Beri Otomotivde Güvenin Adı</strong>
                        </p>
                        <div className="about-content">
                            <p className="about-description">
                                OtoPrime, kurucu ekibinin 2005 yılından bu yana sürdürdüğü emlak ve ticaret alanındaki
                                deneyimi üzerine inşa edilerek, 2020 yılında otomotiv sektörüne adım atmıştır.
                                Kurulduğu günden bu yana ikinci el otomobil alım-satımı, takas ve kredi danışmanlığı
                                alanlarında güvenilir, şeffaf ve çözüm odaklı hizmet sunmayı amaç edinmiştir.
                            </p>

                            <div className="about-description mb-4">
                                <p className="mb-2">Bugün hem bireysel hem kurumsal müşterilerimize:</p>
                                <ul className="feature-list">
                                    <li>Belgeli ve güvenilir araçlar</li>
                                    <li>Krediye uygun finansal çözümler</li>
                                    <li>Ekspertiz ve takas desteği</li>
                                    <li>Kurumsal satış danışmanlığı</li>
                                </ul>
                                <p className="mt-2">
                                    gibi birçok hizmeti bir arada sunarak sadece araç değil, <strong>güven</strong> satıyoruz.
                                </p>
                            </div>

                            <p className="about-description">
                                2025 itibarıyla dijital altyapımızı da güçlendirdik. OtoPrime artık sadece galeride değil,
                                internetin olduğu her yerde yanınızda.
                            </p>
                        </div>
                    </Col>
                </Row>

                {/* Features Section */}
                <Row className="features-section mb-5">
                    <Col lg={3} md={6} className="mb-4">
                        <div className="feature-card">
                            <div className="feature-icon">
                                <FaCheck className="check-icon" />
                            </div>
                            <h4 className="feature-title">Online peşinat ödeme imkanı</h4>
                            <p className="feature-desc">
                                Evden çıkmadan, hızlı ve güvenli bir şekilde peşinat ödemelerinizi yapabilirsiniz.
                            </p>
                        </div>
                    </Col>
                    <Col lg={3} md={6} className="mb-4">
                        <div className="feature-card">
                            <div className="feature-icon">
                                <FaCheck className="check-icon" />
                            </div>
                            <h4 className="feature-title">Kolay ve hızlı değerlendirme süreci</h4>
                            <p className="feature-desc">
                                Başvurularınız uzman ekibimiz tarafından en kısa sürede değerlendirilir.
                            </p>
                        </div>
                    </Col>
                    <Col lg={3} md={6} className="mb-4">
                        <div className="feature-card">
                            <div className="feature-icon">
                                <FaCheck className="check-icon" />
                            </div>
                            <h4 className="feature-title">Aracı kurum yok doğrudan başvuru</h4>
                            <p className="feature-desc">
                                Ekstra komisyon ve aracı maliyeti olmadan doğrudan bizimle iletişime geçebilirsiniz.
                            </p>
                        </div>
                    </Col>
                    <Col lg={3} md={6} className="mb-4">
                        <div className="feature-card">
                            <div className="feature-icon">
                                <FaCheck className="check-icon" />
                            </div>
                            <h4 className="feature-title">Hızlı teslimat kolaylığı</h4>
                            <p className="feature-desc">
                                Onaylanan finansman işlemleriniz sonrası aracınızı hızlıca teslim alabilirsiniz.
                            </p>
                        </div>
                    </Col>
                </Row>

                {/* Mission & Vision Section */}
                <Row className="mission-vision-section">
                    <Col lg={6} className="mb-4">
                        <Card className="mission-card h-100">
                            <Card.Body>
                                <h3 className="section-title">MİSYONUMUZ</h3>
                                <div className="d-flex align-items-center mb-4 mt-4">
                                    <div className="mission-icon me-3">
                                        <FaHandshake />
                                    </div>
                                    <div>
                                        <h5>Güven ve Şeffaflık</h5>
                                        <p>Müşterilerimizle dürüst ve açık iletişim kurarak güven temelli ilişkiler inşa ederiz.</p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center mb-4">
                                    <div className="mission-icon me-3">
                                        <FaCarAlt />
                                    </div>
                                    <div>
                                        <h5>Kaliteli Hizmet</h5>
                                        <p>Her müşteri için özel çözümler sunarak otomobil alım-satım sürecini kolaylaştırırız.</p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center">
                                    <div className="mission-icon me-3">
                                        <FaUserFriends />
                                    </div>
                                    <div>
                                        <h5>Müşteri Memnuniyeti</h5>
                                        <p>Müşterilerimizin ihtiyaçlarını en iyi şekilde anlayarak, beklentilerinin ötesinde hizmet sunarız.</p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col lg={6} className="mb-4">
                        <Card className="vision-card h-100">
                            <Card.Body>
                                <h3 className="section-title">VİZYONUMUZ</h3>
                                <div className="d-flex align-items-center mb-4 mt-4">
                                    <div className="vision-icon me-3">
                                        <FaCarAlt />
                                    </div>
                                    <div>
                                        <h5>Sektör Liderliği</h5>
                                        <p>Türkiye'nin en güvenilir ve tercih edilen ikinci el otomobil finansman markası olmak.</p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center mb-4">
                                    <div className="vision-icon me-3">
                                        <FaClock />
                                    </div>
                                    <div>
                                        <h5>Yenilikçi Çözümler</h5>
                                        <p>Teknolojik yenilikleri takip ederek müşterilerimize her zaman en yeni ve en iyi hizmeti sunmak.</p>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center">
                                    <div className="vision-icon me-3">
                                        <FaHandshake />
                                    </div>
                                    <div>
                                        <h5>Sürdürülebilir Büyüme</h5>
                                        <p>Müşteri memnuniyetini esas alarak, etik değerlerden taviz vermeden büyümeyi sürdürmek.</p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/* Team Section (Optional) */}
                <Row className="mt-5 pt-3">
                    <Col lg={12} className="text-center">
                        <h2 className="section-title">EKİBİMİZ</h2>
                        <p className="team-description mt-4 mb-5">
                            OtoPrime, alanında uzman, deneyimli ve dinamik bir ekiple hizmet vermektedir.
                            Otomotiv sektöründe uzun yıllar deneyimi olan ekibimiz, sizlere en iyi hizmeti
                            sunmak için burada.
                        </p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default AboutUs;